module.exports = __webpack_public_path__ + "static/media/deloitte_logo.cbe541cc.jfif";